module.exports = __webpack_public_path__ + "img/pathologie.30b78057.png";